const GridCardAreaData = {
  label: "2455 sqft.",
  enableLabel: false,
  super_built_up_area: {
    min: {
      ft: 2455,
      mt: 228,
    },
    max: {
      ft: 2455,
      mt: 228,
    },
  },
  built_up_area: {
    min: {
      ft: 2455,
      mt: 228,
    },
    max: {
      ft: 2455,
      mt: 228,
    },
  },
  carpet_area: {
    min: {
      ft: 1841,
      mt: 171,
    },
    max: {
      ft: 1841,
      mt: 171,
    },
  },
  karab_area: {
    min: {
      ft: 2455,
      mt: 228,
    },
    max: {
      ft: 2455,
      mt: 228,
    },
  },
};

export default GridCardAreaData;
